<div class="slider">
    <div>
        <!-- <div (click)="goToPrevious()" class="leftArrow">❰</div>
      <div (click)="goToNext()" class="rightArrow">❱</div> -->
        <div (click)="goToPrevious()" class="leftArrow"><i class="fa-solid fa-chevron-left"></i></div>
        <div (click)="goToNext()" class="rightArrow"><i class="fa-solid fa-chevron-right"></i></div>
    </div>
    <div
        class="slide"
        [ngStyle]="{
            'background-image': getCurrentSlideUrl()
        }"
    ></div>
    <div class="dotsContainer" *ngIf="slides?.length <= 15">
        <div
            *ngFor="let slide of slides; let slideIndex = index"
            class="dot"
            [ngClass]="currentIndex === slideIndex ? 'selected-dot' : ''"
            (click)="goToSlide(slideIndex)"
        >
            <!-- ● -->
            <i class="fa-solid fa-circle"></i>
        </div>
    </div>
</div>
